import { type Content, generateText, isEmptyObject } from "@tiptap/core";
import { logger } from "@/lib/logger";
import { defaultTiptapExtensions } from "./tiptap-extensions";

export const safeGenerateText = (content: Content) => {
	if (typeof content === "string") {
		return content;
	}
	if (!content) {
		return null;
	}
	try {
		return generateText(content, defaultTiptapExtensions);
	} catch (err) {
		logger.error(`[safeGenerateText]`, err);
		return null;
	}
};

export const isContentEmpty = (
	content: unknown,
): content is null | undefined | "" | Record<string, never> => {
	if (!content || isEmptyObject(content)) {
		return true;
	}
	const text = safeGenerateText(content);
	return !text?.trim();
};

export const defaultContent = {
	type: "doc",
	content: [
		{
			type: "paragraph",
			content: [
				{
					text: " ",
					type: "text",
				},
			],
		},
	],
};
